import React, { useState, useRef, useEffect } from 'react';
import { consultationsAPI } from '../../services/api';
import { useSettings } from '../../context/SettingsContext';
import './Contact.css';

const serviceToProjectType = {
  residential: 'new_build',
  commercial: 'commercial',
  renovation: 'renovation',
  interior: 'renovation',
  other: 'new_build',
};

const countryCodes = [
  { code: '+255', country: 'Tanzania', flag: '🇹🇿', short: 'TZ' },
  { code: '+44', country: 'United Kingdom', flag: '🇬🇧', short: 'GB' },
  { code: '+1', country: 'United States', flag: '🇺🇸', short: 'US' },
  { code: '+1', country: 'Canada', flag: '🇨🇦', short: 'CA' },
  { code: '+254', country: 'Kenya', flag: '🇰🇪', short: 'KE' },
  { code: '+256', country: 'Uganda', flag: '🇺🇬', short: 'UG' },
  { code: '+250', country: 'Rwanda', flag: '🇷🇼', short: 'RW' },
  { code: '+243', country: 'DR Congo', flag: '🇨🇩', short: 'CD' },
  { code: '+258', country: 'Mozambique', flag: '🇲🇿', short: 'MZ' },
  { code: '+260', country: 'Zambia', flag: '🇿🇲', short: 'ZM' },
  { code: '+265', country: 'Malawi', flag: '🇲🇼', short: 'MW' },
  { code: '+27', country: 'South Africa', flag: '🇿🇦', short: 'ZA' },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬', short: 'NG' },
  { code: '+233', country: 'Ghana', flag: '🇬🇭', short: 'GH' },
  { code: '+20', country: 'Egypt', flag: '🇪🇬', short: 'EG' },
  { code: '+212', country: 'Morocco', flag: '🇲🇦', short: 'MA' },
  { code: '+251', country: 'Ethiopia', flag: '🇪🇹', short: 'ET' },
  { code: '+91', country: 'India', flag: '🇮🇳', short: 'IN' },
  { code: '+86', country: 'China', flag: '🇨🇳', short: 'CN' },
  { code: '+971', country: 'UAE', flag: '🇦🇪', short: 'AE' },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦', short: 'SA' },
  { code: '+49', country: 'Germany', flag: '🇩🇪', short: 'DE' },
  { code: '+33', country: 'France', flag: '🇫🇷', short: 'FR' },
  { code: '+39', country: 'Italy', flag: '🇮🇹', short: 'IT' },
  { code: '+34', country: 'Spain', flag: '🇪🇸', short: 'ES' },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱', short: 'NL' },
  { code: '+46', country: 'Sweden', flag: '🇸🇪', short: 'SE' },
  { code: '+61', country: 'Australia', flag: '🇦🇺', short: 'AU' },
  { code: '+81', country: 'Japan', flag: '🇯🇵', short: 'JP' },
  { code: '+82', country: 'South Korea', flag: '🇰🇷', short: 'KR' },
  { code: '+55', country: 'Brazil', flag: '🇧🇷', short: 'BR' },
  { code: '+52', country: 'Mexico', flag: '🇲🇽', short: 'MX' },
  { code: '+7', country: 'Russia', flag: '🇷🇺', short: 'RU' },
  { code: '+90', country: 'Turkey', flag: '🇹🇷', short: 'TR' },
  { code: '+48', country: 'Poland', flag: '🇵🇱', short: 'PL' },
  { code: '+47', country: 'Norway', flag: '🇳🇴', short: 'NO' },
  { code: '+45', country: 'Denmark', flag: '🇩🇰', short: 'DK' },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭', short: 'CH' },
  { code: '+43', country: 'Austria', flag: '🇦🇹', short: 'AT' },
  { code: '+32', country: 'Belgium', flag: '🇧🇪', short: 'BE' },
  { code: '+353', country: 'Ireland', flag: '🇮🇪', short: 'IE' },
  { code: '+351', country: 'Portugal', flag: '🇵🇹', short: 'PT' },
  { code: '+30', country: 'Greece', flag: '🇬🇷', short: 'GR' },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿', short: 'NZ' },
  { code: '+65', country: 'Singapore', flag: '🇸🇬', short: 'SG' },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾', short: 'MY' },
  { code: '+63', country: 'Philippines', flag: '🇵🇭', short: 'PH' },
  { code: '+66', country: 'Thailand', flag: '🇹🇭', short: 'TH' },
  { code: '+62', country: 'Indonesia', flag: '🇮🇩', short: 'ID' },
  { code: '+92', country: 'Pakistan', flag: '🇵🇰', short: 'PK' },
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩', short: 'BD' },
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰', short: 'LK' },
  { code: '+972', country: 'Israel', flag: '🇮🇱', short: 'IL' },
  { code: '+974', country: 'Qatar', flag: '🇶🇦', short: 'QA' },
  { code: '+968', country: 'Oman', flag: '🇴🇲', short: 'OM' },
  { code: '+973', country: 'Bahrain', flag: '🇧🇭', short: 'BH' },
  { code: '+965', country: 'Kuwait', flag: '🇰🇼', short: 'KW' },
];

const Contact = () => {
  const { settings } = useSettings();
  const business = settings?.business || {
    name: 'London Builders',
    address: 'Sakina, Raska Zone, Arusha, Tanzania',
    phone: '+255656472123',
    email: 'londonbuilderstz@gmail.com',
    whatsapp: '255656472123',
    workingHours: {
      weekdays: 'Mon-Fri: 8:30am - 5:30pm',
      saturday: 'Sat: 9:00am - 3:00pm',
      sunday: 'Closed'
    }
  };
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [selectedCountry, setSelectedCountry] = useState(countryCodes[0]);
  const [isCodeDropdownOpen, setIsCodeDropdownOpen] = useState(false);
  const [codeSearch, setCodeSearch] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const codeDropdownRef = useRef(null);
  const codeSearchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (codeDropdownRef.current && !codeDropdownRef.current.contains(e.target)) {
        setIsCodeDropdownOpen(false);
        setCodeSearch('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isCodeDropdownOpen && codeSearchRef.current) {
      codeSearchRef.current.focus();
    }
  }, [isCodeDropdownOpen]);

  const filteredCodes = countryCodes.filter(c =>
    c.country.toLowerCase().includes(codeSearch.toLowerCase()) ||
    c.code.includes(codeSearch) ||
    c.short.toLowerCase().includes(codeSearch.toLowerCase())
  );

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (submitStatus) setSubmitStatus(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Map contact form data to consultation API format
      const consultationData = {
        projectType: serviceToProjectType[formData.service] || 'new_build',
        styles: [],
        hasDesigns: 'no',
        fileCategories: [],
        fileDescription: '',
        location: 'To be discussed',
        projectSize: 'not_sure',
        timeline: 'flexible',
        priorities: [],
        additionalNotes: `[Contact Form Enquiry]\nService: ${formData.service}\n\n${formData.message}`,
        contactName: formData.name,
        contactEmail: formData.email,
        contactPhone: formData.phone ? `${selectedCountry.code}${formData.phone}` : '',
        preferredContact: 'phone',
        bestTimeToContact: 'anytime',
      };

      await consultationsAPI.submit(consultationData);
      
      if (window.gtag) {
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17482871892/lGufCNKfhIcbENTovZBB'
        });
      }
      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', service: '', message: '' });
      setSelectedCountry(countryCodes[0]);
    } catch (error) {
      console.error('Failed to submit enquiry:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="contact__container">
        <div className="contact__content">
          <div className="contact__info">
            <span className="section-label section-label--light">Get In Touch</span>
            <h2 className="section-title section-title--light">
              Ready to Start <span className="text-accent">Your Project?</span>
            </h2>
            <p className="contact__description">
              Whether you're planning a new build, renovation, or commercial development, 
              we're here to help bring your vision to life. Get in touch for a free 
              consultation and quote.
            </p>
            
            <div className="contact__details">
              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <div className="contact__detail-text">
                  <strong>Visit Our Office</strong>
                  <span>{business.address}</span>
                </div>
              </div>
              
              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
                  </svg>
                </div>
                <div className="contact__detail-text">
                  <strong>Call Us</strong>
                  <a href={`tel:${business.phone}`}>{business.phone}</a>
                </div>
              </div>
              
              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <div className="contact__detail-text">
                  <strong>Email Us</strong>
                  <a href={`mailto:${business.email}`}>{business.email}</a>
                </div>
              </div>
              
              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                </div>
                <div className="contact__detail-text">
                  <strong>Working Hours</strong>
                  <span>
                    {business.workingHours?.weekdays}<br/>
                    {business.workingHours?.saturday}
                    {business.workingHours?.sunday ? <><br/>{business.workingHours?.sunday}</> : null}
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="contact__form-wrapper">
            <form className="contact__form" onSubmit={handleSubmit}>
              <h3 className="contact__form-title">Request a Free Quote</h3>
              
              <div className="contact__form-row">
                <div className="contact__form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="John Smith"
                    required
                  />
                </div>
                
                <div className="contact__form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="john@example.com"
                    required
                  />
                </div>
              </div>
              
              <div className="contact__form-row">
                <div className="contact__form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <div className="contact__phone-wrapper" ref={codeDropdownRef}>
                    <button
                      type="button"
                      className="contact__country-toggle"
                      onClick={() => setIsCodeDropdownOpen(!isCodeDropdownOpen)}
                      aria-expanded={isCodeDropdownOpen}
                    >
                      <span className="contact__country-flag">{selectedCountry.flag}</span>
                      <span className="contact__country-code">{selectedCountry.code}</span>
                      <svg className={`contact__country-arrow ${isCodeDropdownOpen ? 'contact__country-arrow--open' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="6 9 12 15 18 9"/>
                      </svg>
                    </button>
                    {isCodeDropdownOpen && (
                      <div className="contact__country-dropdown">
                        <div className="contact__country-search">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="11" cy="11" r="8"/>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                          </svg>
                          <input
                            ref={codeSearchRef}
                            type="text"
                            placeholder="Search country..."
                            value={codeSearch}
                            onChange={(e) => setCodeSearch(e.target.value)}
                          />
                        </div>
                        <ul className="contact__country-list">
                          {filteredCodes.map((c, i) => (
                            <li
                              key={`${c.short}-${i}`}
                              className={`contact__country-option ${c.short === selectedCountry.short && c.code === selectedCountry.code ? 'contact__country-option--selected' : ''}`}
                              onClick={() => {
                                setSelectedCountry(c);
                                setIsCodeDropdownOpen(false);
                                setCodeSearch('');
                              }}
                            >
                              <span className="contact__country-flag">{c.flag}</span>
                              <span className="contact__country-name">{c.country}</span>
                              <span className="contact__country-dial">{c.code}</span>
                            </li>
                          ))}
                          {filteredCodes.length === 0 && (
                            <li className="contact__country-empty">No results found</li>
                          )}
                        </ul>
                      </div>
                    )}
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="contact__phone-input"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="712 345 678"
                    />
                  </div>
                </div>
                
                <div className="contact__form-group">
                  <label htmlFor="service">Service Required</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a service</option>
                    <option value="residential">Residential Construction</option>
                    <option value="commercial">Commercial Projects</option>
                    <option value="renovation">Renovations & Extensions</option>
                    <option value="interior">Interior Fit-Outs</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              
              <div className="contact__form-group contact__form-group--full">
                <label htmlFor="message">Project Details</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your project..."
                  rows="5"
                  required
                ></textarea>
              </div>
              
              {submitStatus === 'success' && (
                <div className="contact__status contact__status--success">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                    <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Thank you! Your enquiry has been submitted. We'll get back to you within 24 hours.
                </div>
              )}
              {submitStatus === 'error' && (
                <div className="contact__status contact__status--error">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="15" y1="9" x2="9" y2="15"/>
                    <line x1="9" y1="9" x2="15" y2="15"/>
                  </svg>
                  Failed to submit. Please try again or contact us directly at {business.phone}.
                </div>
              )}
              <button type="submit" className="btn btn--primary contact__submit" disabled={isSubmitting}>
                <span>{isSubmitting ? 'Submitting...' : 'Send Enquiry'}</span>
                {!isSubmitting && (
                  <svg className="btn__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M5 12h14M12 5l7 7-7 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
      
      {/* Background Elements */}
      <div className="contact__bg-pattern"></div>
      <div className="contact__bg-orb"></div>
    </section>
  );
};

export default Contact;

